export default __webpack_public_path__ + "static/media/activity.dc6ef4fd.svg";